import React from 'react';
import { CreditCardIcon, DownloadIcon, InfinityIcon, RepeatIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const reassurances = [{
  icon: CreditCardIcon,
  label: 'Paiement unique'
}, {
  icon: RepeatIcon,
  label: 'Aucun abonnement'
}, {
  icon: DownloadIcon,
  label: 'Accès numérique immédiat'
}, {
  icon: InfinityIcon,
  label: 'Accès à vie'
}];
export function Hero() {
  return <section className="w-full bg-paper px-5 pb-6 pt-6 sm:pb-12 sm:pt-10" data-id="element-120" data-mp="129qvxpsonxpz">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-121" data-mp="xanpq20yvlgf">
        <span className="mb-4 inline-block rounded-full border border-cobalt bg-cobalt/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-cobalt-deep sm:mb-6" data-id="element-122" data-mp="x8jojrugd0ju">
          Pour les professeurs de physique-chimie
        </span>

        <h1 className="font-serif-display text-[26px] font-bold leading-tight text-ink sm:text-5xl md:text-6xl" data-id="element-123" data-mp="3d2l9jc5qb50p">
          Vos cours de chimie n’ont plus besoin de commencer devant une page blanche.
        </h1>

        <p className="mt-3 text-base font-medium text-cobalt-deep sm:mt-5 sm:text-xl" data-id="element-124" data-mp="3j9tymsm91cin">
          Une bibliothèque complète de ressources visuelles, structurées et prêtes à l’emploi pour
          préparer vos cours de chimie plus rapidement, sans tout recréer à chaque séquence.
        </p>

        <p className="mt-3 text-[13px] font-semibold text-ink/70 sm:mt-4 sm:text-sm" data-id="element-125" data-mp="3e84orgarj4w5">
          460 pages • 5 volumes pédagogiques • 4 ressources complémentaires • Accès à vie
        </p>

        <figure className="relative mt-5 w-full max-w-[680px] sm:mt-8" data-id="element-126" data-mp="359t0vm1a6l7e">
          <div className="relative overflow-hidden rounded-[20px] bg-paper shadow-[0_20px_45px_-22px_rgba(31,36,48,0.28)] sm:rounded-[26px]" data-id="element-127" data-mp="2qk3mgp46gkp6">
            <img src="https://cdn.magicpatterns.com/uploads/mcPaTiZzZ2bypp9g298Npi/ChatGPT_Image_16_ago_2026,_09_52_14_p.m..png" alt="Professeure de physique-chimie tenant la bibliothèque CHIMIE VISUELLE™, avec les cinq volumes pédagogiques sur l’étagère" width="1656" height="928" loading="eager" decoding="async" sizes="(max-width: 680px) calc(100vw - 40px), 680px" className="block aspect-[16/9] w-full object-cover" data-id="element-128" data-mp="2vjpvsngvxgsp" />
            <div className="pointer-events-none absolute inset-0 rounded-[20px] ring-1 ring-inset ring-white/45 sm:rounded-[26px]" aria-hidden="true" data-id="element-129" data-mp="dd5eiqyq5n56" />
          </div>
        </figure>

        <p className="mt-5 max-w-xl text-[13px] leading-relaxed text-ink/75 sm:mt-6 sm:text-base" data-id="element-130" data-mp="161jaz2a60bem">
          Schémas, fiches visuelles, activités, séquences, évaluations et corrigés réunis dans une
          seule bibliothèque, classée par notion et par usage.
        </p>

        <div className="mt-6 flex w-full max-w-md flex-col items-center sm:mt-8" data-id="element-131" data-mp="3lsytv2hbkskn">
          <p className="font-serif-display text-4xl font-bold leading-none text-cobalt sm:text-5xl" data-id="element-132" data-mp="3lqm1dvdxqztc">
            19 €
          </p>
          <p className="mt-1.5 text-xs font-medium text-ink/70 sm:text-sm" data-id="element-133" data-mp="1x9umefegzlpj">
            Paiement unique · Accès à vie
          </p>
          <div className="mt-4 w-full" data-id="element-134" data-mp="21bpnbishnx2s">
            <CTAButton label="ACCÉDER À CHIMIE VISUELLE™" data-id="element-135" data-mp="218jzs7zid396" />
          </div>
        </div>

        <ul className="mt-6 grid w-full grid-cols-2 overflow-hidden rounded-2xl border border-cobalt/30 bg-white sm:mt-8 sm:grid-cols-4" data-id="element-136" data-mp="267wlgpen84a6">
          {reassurances.map((item, index) => <li key={item.label} className={`flex flex-col items-center gap-2 px-4 py-4 sm:py-5 ${index % 2 !== 0 ? 'border-l border-cobalt/20' : ''} ${index >= 2 ? 'border-t border-cobalt/20' : ''} sm:border-l sm:border-t-0 sm:first:border-l-0`} data-id="element-137" data-mp="2fzj436tb95my" data-mpi={index}>
              <item.icon className="h-5 w-5 text-cobalt" aria-hidden="true" data-id="element-138" data-mp="umhc873eqbm8" />
              <span className="text-[11px] font-medium leading-snug text-ink sm:text-sm" data-id="element-139" data-mp="uoanjzoytk0k">
                {item.label}
              </span>
            </li>)}
        </ul>
      </div>
    </section>;
}